/* src/app/modules/shared/components/header-column/header-column-helps-with/header-column-helps-with.component.scss */
app-header-column-helps-with {
  display: contents;
}
/*# sourceMappingURL=header-column-helps-with.component.css.map */
